module.exports = __webpack_public_path__ + "img/jennifer_gibson_expert_exchanges_credit_likhaan_3.5352f429.jpg";